import { ReactElement } from "react";
import LayoutCard from "../../../shared-ui-components/LayoutCard";
import { UrlScanCertificate } from "../../../models/url-analysis-data-structures";
import CertificateSummary from "./CertificateSummary";

interface UrlCertificateCardProps {
  certificate: UrlScanCertificate | null;
}

export default function UrlCertificateCard({
  certificate,
}: UrlCertificateCardProps): ReactElement {
  return (
    <LayoutCard>
      {{
        content: (
          <>
            <div className="layout-card-header-text flex-row-with-vertical-alignment">
              TLS Certificate
            </div>
            <CertificateSummary certificate={certificate} />
          </>
        ),
      }}
    </LayoutCard>
  );
}
